export default {
    components: {
        BaseTable: {
            emptyText: "No data found"
        },
        ContentEdit: {
            program: {
                title: "About the training program"
            },
            category: {
                title: "About the training category"
            },
            massage: {
                title: "About the massage program"
            },
            default: {
                title: "About the placeholder"
            },
            textFieldsInfo:
                "All the <em>text fields</em> in this box represent content displayed in the chair's interface.",
            publishState: {
                title: "Publication status (for selected language)",
                notPublished: "Not published",
                test: "Test environment",
                published: "Published"
            }
        },
        InputDropzone: {
            dragActiveLabel: "Drop the audiofile here",
            dragInactiveLabel: "Drag and drop an audiofile here or click to browse"
        },
        LanguageTabs: {
            edited: "Edited",
            unchanged: "Unchanged",
            incomplete: "Incomplete"
        },
        ModalCancel: {
            description: "Are you sure you want to cancel? All changes will be lost."
        },
        ModalConfirmChanges: {
            title: "Confirm changes",
            description: "You are about to save the following changes:",
            change: "Change {field} to \"{value}\"",
            was: "was \"{value}\"",
            noChanges: "No changes to save."
        },
        PreviewAudio: {
            uploadFailed: "Failed to load the audio file for {audio}",
            unsupportedBrowser: "Your browser does not support audio playback.",
            default: "Default"
        },
        PreviewImage: {
            uploadFailed: "Failed to load the image file"
        },
        TimelineBlock: {
            type: {
                neck: "N",
                back: "B",
                legs: "L"
            }
        },
        TimelineEditor: {
            blocks: {
                title: "Blocks"
            },
            timeline: {
                title: "Timeline",
                mismatchingBlocks: "{count} blocks don't fit",
                totalTimeSeconds: "{seconds}s",
                totalTimeMinutes: "{minutes}m{seconds}s"
            }
        },
        OperatingTime: {
            title: "Operating time",
            headers: {
                duration: "Duration",
                hours: "In hours",
                minutes: "In minutes",
                seconds: "In seconds"
            },
            fields: {
                lifetime: "Lifetime",
                total: "Total",
                xMotor: "X-Motor",
                yMotor: "Y-Motor",
                zMotor: "Z-Motor",
                leftMassage: "Left Massage",
                rightMassage: "Right Massage",
                tiltMotor: "Tilt Motor",
                legTilt: "Leg Tilt",
                legMassage: "Leg Massage",
                neckMassage: "Neck Massage",
                heatPad: "Heat Pad"
            }
        }
    },
    layout: {
        ContentLayout: {
            content: {
                title: "Content",
                nav: {
                    categories: "Categories",
                    programs: "Training programs",
                    massages: "Massage programs",
                    static: "Static pages",
                    uicomponents: "UI components"
                }
            },
            app: {
                title: "App"
            },
            chairs: {
                title: "Chairs"
            },
            default: {
                title: "Placeholder"
            }
        }
    },
    pages: {
        settings: {
            title: "Settings",
            adminTab: "Settings",
            fields: {
                admin_pin: "Admin PIN",
                admin_pin_description: "Password to open the tablet's service mode.",
                max_screen_brightness: "Max screen brightness",
                max_screen_brightness_description: "Brightness level when the screen is active (value between 0 and 1).",
                ota_active_version: "Active app version (OTA)",
                ota_active_version_description: "Default app version for all chairs, unless an override is selected.",
                last_online_minute_threshold: "Offline threshold (minutes)",
                last_online_minute_threshold_description: "How many minutes can pass without API contact before the tablet is considered offline.",
                command_max_check_count: "Max ACK check count",
                command_max_check_count_description: "How many times the app checks for an ACK before resending a command.",
                command_max_resend_count: "Max resend count",
                command_max_resend_count_description: "How many times a command is resent before the app aborts due to broken communication.",
                command_queue_timer_interval_ms: "ACK check interval (ms)",
                command_queue_timer_interval_ms_description: "How many milliseconds the app waits between each ACK check.",
                event_log_limit: "Event log limit",
                event_log_limit_description: "How many event logs are shown on the tablet."
            },
            databaseKey: "Database key",
            unknownSetting: "Unknown setting",
            otaConfirmTitle: "Change active app version",
            otaConfirmBody: "You are about to change the default app version for all chairs. The change will take effect the next time the chairs synchronize.",
            otaConfirmNote: "Note: Chairs with an individual version override will continue using their override and will not be affected by this change.",
            saved: "Setting saved.",
            validation: {
                mustBeNumber: "Must be a number.",
                mustBeInteger: "Must be a whole number.",
                minValue: "Minimum allowed value is {min}.",
                maxValue: "Maximum allowed value is {max}.",
                minLength: "Must be exactly {min} characters.",
                maxLength: "Must not be longer than {max} characters."
            }
        },
        invites: {
            title: "Invites",
            adminTab: "Invites",
            renew: "Would you like to renew the invitation and send a new email?",
            delete: "Would you like to delete the invitation?",
            errorRequirements: "You must provide an email and role",
            roles: "Roles",
            allRoles: "All roles",
            noInvites: "No invites found",
            send: "Send invite"
        },
        users: {
            title: "Users",
            adminTab: "Users",
            noUsers: "No users found",
            editUser: "Edit",
            deleteUser: "Delete user",
            confirmDelete: "Are you sure you want to delete \"{name}\"?"
        },
        chairsDetails: {
            markedAsFixed: "{errorCode} marked as fixed",
            markAsFixed: "Mark as fixed",
            errorLog: "Error log",
            toFix: "To fix",
            fixed: "Fixed",
            viewEventLogs: "View event logs",
            contentTree: "Content tree"
        },
        chairEventLogs: {
            title: "Event logs",
            empty: "No event logs found.",
            clearLogs: "Clear logs",
            searchPlaceholder: "Search by id, command or value...",
            deleted: "All event logs have been deleted.",
            confirmClearTitle: "Clear event logs",
            confirmClearBody: "Are you sure you want to delete all event logs for this chair? This action cannot be undone.",
            confirmClearButton: "Yes, clear logs",
            ioFilterLabel: "Filter by i/o",
            ioFilter: {
                all: "i/o: All"
            },
            columns: {
                isarId: "Isar #",
                timestamp: "Timestamp",
                io: "i/o",
                eventId: "ID",
                command: "Command",
                value: "Value"
            }
        },
        chairs: {
            noCustomer: "No customer",
            noSeller: "No seller",
            title: "Chairs"
        },
        chairsSave: {
            create: "Create new chair",
            configure: "Configure chair",
            chooseSeller: "Choose seller",
            chooseMarket: "Choose market",
            chooseCustomer: "Choose customer",
            chooseSector: "Choose sector",
            chooseSegment: "Choose segment",
            chooseAreaTags: "Choose area tag",
            addNewCustomer: "Add new customer",
            addNewSeller: "Add new seller",
            addNewTag: "Add new area tag on the {market} market",
            errorAreaTagExists: "There is already an area with this name",
            chairData: "Chair data",
            sellerAndCustomer: "Seller and customer",
            testChair: "Test chair",
            testChairInfo:
                "(This chair can show unpublished content created by SuperAdmin)",
            modalInfo: "This is added for the market <strong>{market}</strong>",
            deleteChair: "Delete chair",
            confirmDelete: "Are you sure you want to delete \"{name}\"?"
        },
        contentCategorySave: {
            editCategory: "Edit category",
            createCategory: "Create category",
            dropImage: "Drop the image here",
            addImage: "Add image",
            changeImage: "Change image",
            selectedPrograms: "Selected training programs",
            noPrograms:
                "<strong>Drag in</strong> one or more of the available training programs.",
            availablePrograms: "Available training programs",
            allAvailablePrograms:
                "All available training programs are already included.",
            deleteCategory: "Delete category",
            deleteCategoryConfirm: "Are you sure you want to delete \"{name}\"?"
        },
        contentMassageSave: {
            editProgram: "Edit massage program",
            createNewProgram: "Create new massage program",
            deleteProgram: "Delete massage program",
            confirmDelete: "Are you sure you want to delete \"{name}\"?"
        },
        contentStaticSave: {
            title: "Edit {name}"
        },
        contentTrainingSave: {
            editProgram: "Edit training program",
            createNewProgram: "Create new training program",
            deleteProgram: "Delete training program",
            confirmDelete: "Are you sure you want to delete \"{name}\"?",
            uploadedAudioTracks: "Uploaded audio tracks",
            audioTrackTooltip:
                "You can only rename or mark uploaded audio tracks for deletion",
            uploadNewAudioTracks: "Upload new audio tracks",
            addAudioFile: "Add audio file",
            audioFileRequirements: "Max {maxSize}. {types}.",
            marketsInfo:
                "Markets where this training program is available, select at least one. If Promas Global is selected, the program will be available for all markets.",
            noMarketsSelectedError: "Choose at least one market"
        },
        contentUiComponentsSave: {
            editComponent: "Edit {name}"
        },
        customers: {
            title: "Customers"
        },
        customersSave: {
            editCustomer: "Edit customer",
            createCustomer: "Create customer",
            createSector: "Create sector",
            createSegment: "Create segment",
            sectorAndSegment: "Sector and segment",
            deleteCustomer: "Delete customer",
            confirmDelete: "Are you sure you want to delete \"{name}\"?"
        },
        market: {
            editMarket: "Edit market",
            createMarket: "Create market",
            deleteMarket: "Delete market",
            confirmDelete: "Are you sure you want to delete \"{name}\"?",
            errorAreaTagExists: "There is already an area tag with this name",
            errorAreaTagRequired: "An area tag must have a name",
            deleteAreaTag: "Delete area tag",
            confirmDeleteAreaTag:
                "Are you sure you want to delete area tag \"{name}\"?",
            contentTree: "Content tree",
            contentTreePage: {
                overview: "Overview",
                requiredLanguages: "Required languages",
                primary: "primary",
                categories: "Categories",
                programs: "Training programs",
                categoryTexts: "Category texts",
                programTexts: "Program texts",
                massagePrograms: "Massage programs",
                noMassagePrograms: "No massage programs",
                uncategorized: "Uncategorized",
                isTest: "Test",
                expandAll: "Expand all",
                collapseAll: "Collapse all",
                categoryLabel: "Category",
                programLabel: "Training program",
                massageLabel: "Massage program",
                chairContextTitle: "Showing content for this chair",
                testChair: "Test chair",
                productionChair: "Production chair",
                scopeLabel: "Shows",
                scopeProduction: "Published content only (green)",
                scopeStaging: "Published and test content (green + orange)",
                noContent:
                    "No training programs are connected to this market.",
                state: {
                    visible: "Visible",
                    test_only: "Test chairs only",
                    hidden: "Hidden"
                },
                textStatus: {
                    published: "Published",
                    test_only: "Test chairs only",
                    unpublished: "Unpublished",
                    missing: "Missing"
                },
                legend: {
                    visible: "Shown on all chairs",
                    test_only: "Shown on test chairs only",
                    hidden: "Not shown",
                    note: "Test (staging) chairs render orange and green content. Regular chairs require green."
                },
                reasons: {
                    missing_category_text:
                        "Category is missing a text in: {languages}",
                    no_qualifying_program:
                        "No training program qualifies for this market (missing a text in some language)",
                    only_test_programs:
                        "Only programs shown on test chairs",
                    no_visible_programs:
                        "No visible training programs – the category is empty",
                    uncategorized:
                        "Programs without a category are not sent to the app",
                    missing_program_text:
                        "Missing program text in: {languages}",
                    program_text_unpublished:
                        "Program text unpublished in: {languages}",
                    program_text_test_only:
                        "Program text for test chairs only in: {languages}",
                    no_visible_massage_programs: "No visible massage programs",
                    only_test_massage_programs:
                        "Only massage programs for test chairs",
                    missing_massage_text:
                        "Massage program is missing a text in: {languages}",
                    massage_test_only:
                        "Marked as test for this program (test chairs only)"
                }
            }
        },
        sellers: {
            editSeller: "Edit seller",
            createSeller: "Create seller",
            deleteSeller: "Delete seller",
            confirmDelete: "Are you sure you want to delete \"{name}\"?",
            chooseMarket: "Choose market"
        },
        invite: {
            inviteToFor: "{email} has been invited to the role of {role}."
        },
        docs: {
            installation: {
                title: "Installation guide",
                description: "Step-by-step guide for installing the tablet."
            },
            guide: {
                title: "Service guide",
                description: "Guide for servicing and maintaining the chair."
            },
            addCustomer: {
                title: "Add new customer",
                description:
                    "How to add a customer from Upsales to admin, and give their users access to Reload Hub."
            },
            issues: {
                title: "Issue tracker",
                description: "Direct link to issue tracker Excel."
            },
            hanzaLog: {
                title: "Hanza Log",
                description: "Direct link to Hanza's production log."
            },
            errorCodes: {
                title: "Error codes & Service blocks",
                description: "Version 22"
            }
        }
    },
    label: {
        appVersion: "App version",
        areas: "Area tags",
        allAreas: "All area tags",
        createdAt: "Created at",
        customer: "Customer",
        customers: "Customers",
        allCustomers: "All customers",
        description: "Description",
        body: "Body",
        error_code: "Error code prefix",
        email: "Email",
        errorCode: "Error code",
        errorDefinition: "Definition",
        firmwareVersion: "Firmware version",
        fixedAt: "Fixed at",
        isStaging: "Is test",
        lastOnline: "Last online",
        batteryLevel: "Battery level",
        androidVersion: "Android version",
        device: "Device",
        lastMassageRunAt: "Last massage",
        location: "Location",
        market: "Market",
        markets: "Markets",
        allMarkets: "All markets",
        selectMarket: "Select market",
        noMarket: "No market",
        portalCustomer: "Reload Hub customer",
        noPortalCustomer: "No Reload Hub customer",
        upsalesCompany: "Company from Upsales",
        noUpsalesCompany: "No company from Upsales",
        portalCustomerTaken: "linked to {name}",
        portalCustomerTakenGeneric: "already linked",
        portalCustomerDisabled: "access disabled",
        portalCustomerNoUsers: "no users yet",
        name: "Name",
        addName: "Add name",
        role: "Role",
        roles: "Roles",
        allRoles: "All roles",
        seller: "Seller",
        sellers: "Sellers",
        serial: "Serial number",
        title: "Title",
        token: "Token",
        type: "Type",
        url: "Link",
        sector: "Sector",
        selectSector: "Select sector",
        allSectors: "All sectors",
        segment: "Segment",
        selectSegment: "Select segment",
        allSegments: "All segments",
        internalName: "Internal name",
        image: "Image",
        recommendedChoice: "Recommended choice",
        testEnvironment: "Test environment",
        massagePrograms: "Massage programs",
        primaryLanguage: "Primary language",
        namePlaceholder: "Name Surnameovich",
        password: "Password",
        confirmPassword: "Confirm password",
        passwordRequirements: "Password must be at least 8 characters.",
        notSelected: "Not selected",
        searchBySerial: "Search by serial number",
        status: "Status",
        allStatuses: "All statuses",
        isOnline: "Online",
        isOffline: "Offline",
        onlineStatus: "Online status",
        allOnlineStatuses: "All chairs",
        state: "State",
        allStates: "All states",
        overrideAppVersion: "Override app version",
        defaultAppVersion: "Default app version",
        availableLanguages: "Available languages",
        showOnlyWithSerial: "Show only with serial number",
        languages: "Languages"
    },
    common: {
        deny: "Deny",
        accept: "Accept",
        promas: "Promas Admin",
        edit: "Edit",
        create: "Create",
        save: "Save",
        saveChanges: "Save changes",
        add: "Add new",
        confirm: "Confirm",
        cancel: "Cancel",
        delete: "Delete",
        close: "Close",
        yes: "Yes",
        no: "No",
        logout: "Logout",
        login: "Login",
        back: "Back",
        return: "Return",
        renew: "Renew",
        ready: "Ready",
        configure: "Configure",
        details: "Details",
        loading: "Loading...",
        hello: "Hello {name}"
    },
    error: {
        fourOFour: "404 Not Found"
    },
    nav: {
        home: {
            title: "Home"
        },
        content: {
            title: "Content",
            description:
                "Massage program, training program, categories, static pages and interface language."
        },
        markets: {
            title: "Markets",
            description:
                "Division and separation of different areas, also called markets."
        },
        chairs: {
            title: "Chairs",
            description: "New chairs, old chairs and all other chairs."
        },
        customers: {
            title: "Customers",
            description: "Data, data and more data about customers"
        },
        sellers: {
            title: "Sellers",
            description: "Data, data and more data about sellers"
        },
        users: {
            title: "Users",
            description: "Users of the system"
        },
        docs: {
            title: "Documentation",
            description: "Guides and documentation for Promas."
        },
        admin: {
            title: "Admin",
            description: "Administer who can administer Promas Admin."
        }
    },
    chairState: {
        storage: "In storage",
        service: "Under maintenance",
        customer: "With customer"
    }
};
